module.exports = __webpack_public_path__ + "static/media/icn_mail_id.f1a77e59.svg";